/**
 * Enum para los estados de aplicación de candidatos a ofertas laborales
 */
export enum ApplicationStatusEnum {
  Pendiente = 1,
  Entrevista = 2,
  Aprobado = 3,
  Rechazado = 4,
  Contratado = 5,
  Otro = 99
}

/**
 * Métodos de utilidad para el enum ApplicationStatusEnum
 */
export class ApplicationStatusUtils {
  /**
   * Convierte un ID de estado a su nombre correspondiente
   */
  static getStatusName(statusId: ApplicationStatusEnum): string {
    return ApplicationStatusEnum[statusId];
  }
  
  /**
   * Obtiene el ID de estado a partir de su nombre
   */
  static getStatusId(statusName: string): ApplicationStatusEnum {
    return ApplicationStatusEnum[statusName as keyof typeof ApplicationStatusEnum];
  }
  
  /**
   * Obtiene todos los estados como un array de objetos {id, name}
   */
  static getAllStatuses(): { id: ApplicationStatusEnum; name: string }[] {
    return Object.keys(ApplicationStatusEnum)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        id: ApplicationStatusEnum[key as keyof typeof ApplicationStatusEnum],
        name: key
      }));
  }
}
